import { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getHost = (url: string) => {
  const urlObject = new URL(url);
  return urlObject.hostname;
};

export const validateEmail = (email: string): void => {
  if (!email) {
      throw new Error("Email is required");
  }

  const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validDomainRegex = /^[^\s@]+\.[^\s@]+$/;

  if (!emailValidation.test(email)) {
      throw new Error("Please enter a valid email address");
  }

  const domain = email.split("@")[1];
  if (!domain || !validDomainRegex.test(domain)) {
      throw new Error("Please enter a valid email address");
  }
};
